import { Link, useLocation } from "react-router-dom";
import { User, FileText, Heart, MessageCircle, Settings, ShieldCheck } from "lucide-react";

const ITEMS = [
  { to: "/mon-compte", icon: User, label: "Mon compte", testid: "side-mon-compte" },
  { to: "/mes-annonces", icon: FileText, label: "Mes annonces", testid: "side-mes-annonces" },
  { to: "/mes-transactions", icon: ShieldCheck, label: "Paiements securises", testid: "side-mes-transactions" },
  { to: "/favoris", icon: Heart, label: "Favoris", testid: "side-favoris" },
  { to: "/messages", icon: MessageCircle, label: "Messages", testid: "side-messages" },
  { to: "/parametres", icon: Settings, label: "Parametres", testid: "side-parametres" },
];

export default function AccountSidebar() {
  const loc = useLocation();
  return (
    <aside className="glass-card p-3 h-fit lg:sticky lg:top-24" data-testid="account-sidebar">
      <nav className="flex lg:flex-col flex-wrap gap-1">
        {ITEMS.map(({ to, icon: Icon, label, testid }) => {
          const active = loc.pathname === to || (to !== "/mon-compte" && loc.pathname.startsWith(to));
          return (
            <Link
              key={to}
              to={to}
              data-testid={testid}
              className={`flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold transition-colors ${active ? "bg-gradient-to-r from-orange-500 to-orange-400 text-white" : "text-[var(--ink)] hover:bg-orange-50/60"}`}
            >
              <Icon size={14} /> {label}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
